import {
  Card,
  Descriptions,
  Button,
  Modal,
  Form,
  Input,
  message,
  Space,
  Typography,
} from "antd";
import React, { useState, useEffect } from "react";
import { get, post } from "../../utils/http";

const { Text } = Typography;

interface ConfigItem {
  config_key: string;
  config_value: string;
  label: string;
}

const configList: ConfigItem[] = [
  {
    config_key: "image_prompt",
    config_value: "",
    label: "图片生成AI prompt",
  },
  {
    config_key: "dialog_prompt",
    config_value: "",
    label: "对话生成AI prompt",
  },
  {
    config_key: "points_register_gift",
    config_value: "100",
    label: "新用户注册赠送积分",
  },
  {
    config_key: "points_unlock_scene",
    config_value: "-10",
    label: "解锁场景扣除积分",
  },
  {
    config_key: "points_finish_scene",
    config_value: "20",
    label: "完成场景奖励积分",
  },
  {
    config_key: "points_review_scene",
    config_value: "5",
    label: "复习场景奖励积分",
  },
  {
    config_key: "points_daily_checkin",
    config_value: "10",
    label: "每日签到奖励积分",
  },
  {
    config_key: "points_share",
    config_value: "15",
    label: "分享/成功邀请奖励(邀请人)",
  },
  {
    config_key: "points_invitee_gift",
    config_value: "20",
    label: "接受邀请新人礼包(被邀请人)",
  },
];

function SystemConfig() {
  const [configs, setConfigs] = useState<ConfigItem[]>(configList);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingConfig, setEditingConfig] = useState<ConfigItem | null>(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    try {
      const response = await get("/api/manage/configs");
      if (response?.data?.code === 0) {
        const data = response.data.data || [];
        const updatedConfigs = configList.map((config) => {
          const found = data.find(
            (item: any) => item.config_key === config.config_key
          );
          return {
            ...config,
            config_value: found ? found.config_value : "",
          };
        });
        setConfigs(updatedConfigs);
      }
    } catch (error) {
      console.error("🚀 ~ fetchConfigs ~ error:", error);
    }
  };

  const handleEdit = (config: ConfigItem) => {
    setEditingConfig(config);
    form.setFieldsValue({ config_value: config.config_value });
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
    setEditingConfig(null);
    form.resetFields();
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      await post("/api/manage/config-save", {
        config_key: editingConfig?.config_key,
        config_value: values.config_value,
      });
      message.success("保存成功");
      setModalVisible(false);
      setEditingConfig(null);
      form.resetFields();
      fetchConfigs();
    } catch (error) {
      console.error("🚀 ~ handleSave ~ error:", error);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="系统配置">
        <div style={{ marginBottom: 16 }}>
          <Text
            strong
            style={{ fontSize: 16, display: "block", marginBottom: 8 }}
          >
            AI配置
          </Text>
        </div>
        <Descriptions column={1} bordered>
          {configs.map((config) => (
            <Descriptions.Item
              key={config.config_key}
              label={config.label}
              labelStyle={{ width: 200 }}
            >
              <Space>
                <span style={{ flex: 1 }}>{config.config_value || "-"}</span>
                <Button type="link" onClick={() => handleEdit(config)}>
                  修改
                </Button>
              </Space>
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Card>

      <Modal
        title={`修改${editingConfig?.label}`}
        open={modalVisible}
        onOk={handleSave}
        onCancel={handleCancel}
        okText="保存"
        cancelText="取消"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label={editingConfig?.label}
            name="config_value"
            rules={[
              { required: true, message: `请输入${editingConfig?.label}` },
            ]}
          >
            <Input.TextArea
              rows={6}
              placeholder={`请输入${editingConfig?.label}`}
            />
          </Form.Item>
          <Form.Item>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {`可在prompt任意位置使用以下变量：@{name}@代表场景名称，@{desc}@代表场景描述，@{module}@代表所属模块`}
            </Text>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default SystemConfig;
